import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client';
import isDev from '@/utils/verifyDevelopmentEnv';

function SocketClient() {
  const { VUE_APP_SOCKET } = process.env;

  let connecting = null;

  const socket = new SockJS(VUE_APP_SOCKET);
  const socketClient = Stomp.over(socket, {
    debug: isDev(),
    protocols: ['v12.stomp'],
  });

  socketClient.connectPromise = (headers = {}) => {
    if (!connecting) {
      connecting = new Promise((resolve, reject) =>
        socketClient.connect(headers, resolve, reject),
      );
    }

    return connecting;
  };

  socketClient.disconnectPromise = (headers = {}) =>
    socketClient.connected
      ? new Promise(resolve => socketClient.disconnect(resolve, headers))
      : Promise.resolve(true);

  return socketClient;
}

export default SocketClient();
